import {Avatar} from 'shells/avatar/avatar';
import {IconAvatar} from 'shells/avatar/icon-avatar';
import {colors} from 'shells/colors/colors';
import {PersonRoundRegularIcon} from 'shells/icon/svg/person-round-regular-icon';

import type {ContactPageFragment, NutFileInput} from 'nutshell-graphql-types';

import {usePreloadAvatar} from '../../hooks/use-preload-avatar';
import {PeepAvatarPicker} from '../../shared/header/avatar/peep-avatar-picker';

interface Props {
    contact: ContactPageFragment;
    onUpdateAvatar: (avatarFile: NutFileInput | null) => Promise<any>;
}

export function ContactAvatar(props: Props) {
    const {displayedAvatarUrl, shouldShowUploadedAvatar} = usePreloadAvatar({
        avatarUrl: props.contact.avatarUrl,
        hasUploadedAvatar: props.contact.hasUploadedAvatar,
    });

    return (
        <PeepAvatarPicker
            peepType='contact'
            hasUploadedAvatar={props.contact.hasUploadedAvatar}
            canDeleteAvatar={props.contact.canDeleteAvatar}
            onRemoveAvatar={() => {
                props.onUpdateAvatar(null);
            }}
            onUploadSuccess={(file) => {
                props.onUpdateAvatar(file);
            }}
        >
            {shouldShowUploadedAvatar ? (
                <Avatar avatarUrl={displayedAvatarUrl} size={72} type='contacts' />
            ) : (
                <IconAvatar
                    icon={PersonRoundRegularIcon}
                    avatarSize={72}
                    iconSize={45}
                    backgroundColor={colors.blueBg}
                    iconColor={colors.blueDk}
                />
            )}
        </PeepAvatarPicker>
    );
}
